
import { Footerdemo } from "@/components/ui/footer-section";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-studio-cream">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-studio-stone">Terms of Service</h1>
        <div className="prose max-w-none text-studio-stone/80">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">1. Acceptance of Terms</h2>
          <p className="mb-4">By accessing and using the services provided by WireFuseMedia, LLC ("we," "our," or "us"), you agree to be bound by these Terms of Service.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">2. Description of Services</h2>
          <p className="mb-4">We provide podcast studio rental and recording services. Our services include studio time, equipment usage, and related support services.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">3. Booking and Cancellation</h2>
          <p className="mb-4">All bookings are subject to availability. Cancellations must be made at least 24 hours in advance of your scheduled session.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">4. Payment Terms</h2>
          <p className="mb-4">Payment is required at the time of booking. We accept major credit cards and other payment methods as specified during the booking process.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">5. Studio Rules and Guidelines</h2>
          <p className="mb-4">Users must follow all studio rules and guidelines provided during the booking process and posted in the studio.</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4 text-studio-stone">6. Contact Information</h2>
          <p className="mb-4">For any questions about these Terms of Service, please contact us at: interview@mindhack.com</p>
        </div>
      </div>
      <Footerdemo />
    </div>
  );
};

export default TermsOfService;
